"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var warning_1 = require("../util/warning");
var warned = {};
function deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
        var args = [];
        for (var _i = 5; _i < arguments.length; _i++) {
            args[_i - 5] = arguments[_i];
        }
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] != null) {
            var messageKey = componentName + "." + propName;
            warning_1.default(warned[messageKey], "The " + location + " `" + propFullNameSafe + "` of " +
                ("`" + componentNameSafe + "` is deprecated. " + reason + "."));
            warned[messageKey] = true;
        }
        return validator.apply(void 0, __spreadArrays([props, propName, componentName, location, propFullName], args));
    };
}
exports.deprecated = deprecated;
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (deprecated) {
    // eslint-disable-next-line no-inner-declarations
    function _resetWarned() {
        warned = {};
    }
    deprecated._resetWarned = _resetWarned;
})(deprecated = exports.deprecated || (exports.deprecated = {}));
